import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiErrorMessage, apiGet } from "../../api/client";

/**
 * Systems (demo step 8): what the workforce reaches, how each is signed in
 * to, and whether it is connected or still planned. Read-only; the XI socket
 * line says plainly that nothing connects out to Xamun.
 */
interface SystemRow {
  id: string;
  name: string;
  kind_words: string;
  auth: string;
  auth_words: string;
  status: "registered" | "planned";
  notes: string | null;
}

export function Systems() {
  const { workspaceId = "" } = useParams();
  const q = useQuery({
    queryKey: ["systems", workspaceId],
    queryFn: () => apiGet<{ xi_socket: { connected: boolean }; systems: SystemRow[] }>(`/api/workspaces/${workspaceId}/systems`),
  });
  const systems = q.data?.systems ?? [];
  return (
    <div className="main-inner" data-testid="systems">
      <div className="greet-row">
        <span className="greet">Systems</span>
      </div>
      <div className="subgreet">
        <div className="section-eyebrow">WHAT THE AGENTS REACH</div>
        <div className="lede">
          {q.isLoading ? "Reading…" : `${systems.length} ${systems.length === 1 ? "system" : "systems"}, each reached the way your IT team decides.`}
        </div>
        {q.data ? (
          <div className="play-meta" style={{ marginTop: 6 }}>
            <span>XI socket: {q.data.xi_socket.connected ? "on" : "off"}. Nothing connects out to Xamun.</span>
          </div>
        ) : null}
      </div>
      {q.isError ? <span className="pill red">{apiErrorMessage(q.error)}</span> : null}
      <div className="play-grid">
        {systems.map((s) => (
          <div key={s.id} className="play-card" data-testid={`system-${s.id}`}>
            <div className="play-head">
              <div>
                <div className="play-arch">{s.kind_words}</div>
                <div className="play-title">{s.name}</div>
              </div>
              <div className="play-status">
                <span className={`pill ${s.status === "registered" ? "green" : "amber"}`}>{s.status === "registered" ? "Connected" : "Planned"}</span>
              </div>
            </div>
            <div className="play-meta">
              <span>{s.auth === "sso" ? `Signed in via ${s.auth_words}` : s.auth_words}</span>
              {s.notes ? <span>{s.notes}</span> : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
